module.exports = __webpack_public_path__ + "img/roll_d.ed742970.png";